export const InboxSteps = [
	{
		selector: '[data-tour="inbox-one"]',
		content: 'List of submitted requests with current public key and received response files.',
	},
	{
		selector: '[data-tour="inbox-two"]',
		content: 'Public key of angels who contributed',
	},
	{
		selector: '[data-tour="inbox-three"]',
		content: 'approved responses which are checked, wage tokens will be sent to. ',
	},
];
